import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const div = document.getElementById('leaflets_edit_recommend_ingredients');
  if (div == null) {
    return;
  }

  const ingredientImages = document.querySelectorAll('.ingredient-image');
  const allRemoveCheckButton = document.querySelector('.all-remove-check') as HTMLElement;
  const maxRecommendRecipeSize = 6;

  const refreshIngredientImageChecked = () => {
    ingredientImages.forEach(ingredientImage => {
      // チェックされているものは選択状態にする
      const checkbox = (ingredientImage as HTMLElement).querySelector('.recommend-ingredient-id') as HTMLInputElement;
      const checked = checkbox.checked;
      if (checked) {
        (ingredientImage as HTMLElement).classList.add('selected');
      } else {
        (ingredientImage as HTMLElement).classList.remove('selected');
      }
    });
  }

  ingredientImages.forEach(ingredientImage => {
    (ingredientImage as HTMLElement).addEventListener('click', () => {
      const checkedBoxes = document.querySelectorAll('.recommend-ingredient-id:checked');
      const checkbox = (ingredientImage as HTMLElement).querySelector('.recommend-ingredient-id') as HTMLInputElement;
      // チェック済みの時はチェックを外せるようにする & 個数制限
      if (checkbox.checked || checkedBoxes.length < maxRecommendRecipeSize) {
        const checked = checkbox.checked;
        checkbox.checked = !checked;
      } else {
        alert('選択できる食材は' + maxRecommendRecipeSize + '個までです');
      }
      refresh();
    });
  });

  allRemoveCheckButton.addEventListener('click', () => {
    const checkedBoxes = document.querySelectorAll('.recommend-ingredient-id:checked');
    checkedBoxes.forEach(checkedBox => {
      (checkedBox as HTMLInputElement).checked = false;
    });
    refresh();
  });

  // 登録時に実行
  div.addEventListener('submit', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'update_content',
      'recommend_ingredients',
      'レシピ提案を更新しました'
    );
  })

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 更新したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  const refresh = () => {
    refreshIngredientImageChecked();
  }

  const initialize = () => {
    refresh();
  }

  initialize();
});
